export default __webpack_public_path__ + "static/media/home.3bcb9a77.svg";